import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "breakout-rooms-editor__main" }
const _hoisted_3 = {
  class: "breakout-rooms-editor__caption",
  for: "room-number"
}
const _hoisted_4 = {
  key: 0,
  class: "breakout-rooms-editor__error-hint"
}
const _hoisted_5 = { class: "breakout-rooms-editor__caption" }
const _hoisted_6 = { class: "breakout-rooms-editor__buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcInputField = _resolveComponent("NcInputField")
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_BreakoutRoomsParticipantsEditor = _resolveComponent("BreakoutRoomsParticipantsEditor")
  const _component_NcModal = _resolveComponent("NcModal")

  return (_openBlock(), _createBlock(_component_NcModal, {
    class: _normalizeClass({ 'modal-mask__participants-step': $setup.isEditingParticipants }),
    "label-id": $setup.dialogHeaderId,
    onClose: _cache[7] || (_cache[7] = $event => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["breakout-rooms-editor", { 'breakout-rooms-editor__participants-step': $setup.isEditingParticipants }])
      }, [
        _createElementVNode("h2", {
          id: $setup.dialogHeaderId,
          class: "nc-dialog-alike-header"
        }, _toDisplayString($options.modalTitle), 9, _hoisted_1),
        (!$setup.isEditingParticipants)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("label", _hoisted_3, _toDisplayString($options.t('spreed', 'Number of breakout rooms')), 1),
                ($setup.isInvalidAmount)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($options.t('spreed', 'You can create from 1 to 20 breakout rooms.')), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_NcInputField, {
                  id: "room-number",
                  ref: "inputField",
                  modelValue: $setup.amount,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.amount) = $event)),
                  class: "breakout-rooms-editor__number-input",
                  type: "number",
                  min: "1",
                  max: "20"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_5, _toDisplayString($options.t('spreed', 'Assignment method')), 1),
                _createElementVNode("fieldset", null, [
                  _createVNode(_component_NcCheckboxRadioSwitch, {
                    modelValue: $setup.mode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.mode) = $event)),
                    value: "1",
                    name: "mode_radio",
                    type: "radio"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.t('spreed', 'Automatically assign participants')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_NcCheckboxRadioSwitch, {
                    modelValue: $setup.mode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.mode) = $event)),
                    value: "2",
                    name: "mode_radio",
                    type: "radio"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.t('spreed', 'Manually assign participants')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_NcCheckboxRadioSwitch, {
                    modelValue: $setup.mode,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.mode) = $event)),
                    value: "3",
                    name: "mode_radio",
                    type: "radio"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.t('spreed', 'Allow participants to choose')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                ($setup.mode === '2')
                  ? (_openBlock(), _createBlock(_component_NcButton, {
                      key: 0,
                      variant: "primary",
                      disabled: $setup.isInvalidAmount,
                      onClick: _cache[4] || (_cache[4] = $event => ($setup.isEditingParticipants = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'Assign participants to rooms')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : (_openBlock(), _createBlock(_component_NcButton, {
                      key: 1,
                      variant: "primary",
                      disabled: $setup.isInvalidAmount,
                      onClick: $options.handleCreateRooms
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.t('spreed', 'Create rooms')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
              ])
            ], 64))
          : (_openBlock(), _createBlock(_component_BreakoutRoomsParticipantsEditor, {
              key: 1,
              token: $props.token,
              "room-number": $setup.amount,
              onClose: _cache[5] || (_cache[5] = $event => (_ctx.$emit('close'))),
              onBack: _cache[6] || (_cache[6] = $event => ($setup.isEditingParticipants = false)),
              onCreateRooms: $options.handleCreateRooms
            }, null, 8, ["token", "room-number", "onCreateRooms"]))
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "label-id"]))
}